import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RestudyEconomicManagerDecision, RestudyEconomicDecision, FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ReleaseRestudyRequestDTO, ReleaseRestudyAdminDTO ,ReleaseOpject,ReleaseFormStartWFDTO} from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';


@Component({
  selector: 'app-Restudy-Notify-Creator',
  templateUrl: './Restudy-NotifyCreator.component.html'
})
export class RestudyNotifyCreatorComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  restudyRequestObj: ReleaseRestudyRequestDTO = new ReleaseRestudyRequestDTO();
  restudyAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  decision = RestudyEconomicManagerDecision;
  managerdecision = RestudyEconomicDecision;
  eunitSignedUsersCount: number;
  isRequireModification: boolean = true;
  RequireModificationNote: string = "";
  isRestudy: boolean = true;
  isRefund: boolean = true;
  isCancelRebate: boolean = false;
  decisionKeys = Object.keys(this.decision);
  ManagerdecisionKeys = Object.keys(this.managerdecision);
  displayedLang: string;
  ShowApprove: boolean = false;
  ShowModify: boolean = false;
  decisionValue: number;
  MdecisionValue: number = 0;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  showProceedToManagers: boolean = false;
  user: User = new User();
  showML: boolean = false;
  isSubmitButtonDisplayed: boolean = false;
  restudyManagerForm: FormGroup;
  EconomicManagerForm: FormGroup;
  NewActualRebatePercentage :string = '';
  private isSubmitEnabled: boolean = false;
  isWFSubmitButtonDisplayed: boolean = false;
  showModifications:boolean = false;
  moreInfoMessage: string = "";
  diffAmount: string="";
  initiateworkflowForm: FormGroup;
  CancelRebateworkflowForm: FormGroup;
  public releaseFormLoaded: ReleaseOpject = new ReleaseOpject();
  public WorkflowActionForm: FormGroup;
  releaseformid : string;
  responseObj: ResponseObject = new ResponseObject();
  private initateRefundObj: ReleaseFormStartWFDTO = new ReleaseFormStartWFDTO();
  requestStatus: number;
  showAmount: boolean = false;


  private getRebateRequestResponseObject: ResponseObject = new ResponseObject();
  private getReleaseFormResponseObject: ResponseObject = new ResponseObject();
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  selectedEmails: [] = [];
  private isFormSubmitted: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,

    private longhaulserv: LongHaulService) {

    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.ManagerdecisionKeys = this.ManagerdecisionKeys.slice(this.ManagerdecisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
    this.buildManagerForm(1);
    this.buildForm(3)
    this.loadListOfAdmins();
  }
  loadListOfAdmins() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RefundFirstReviewer').subscribe(d => {
      this.ListOfAdmins = d.Data;
      this.showML = true;
      this.isWFSubmitButtonDisplayed = true;
      this.globalSrv.IsLoaderEnabled = false;
    });
  }
  buildManagerForm(decisionValue) {

    this.EconomicManagerForm = this.formBuilder.group({
      ManagerDecision: ['', [Validators.required]],
    })
    if (decisionValue == RestudyEconomicDecision.ManagerApprove) {
      this.EconomicManagerForm = this.formBuilder.group({
        ManagerDecision: ['', [Validators.required]],
        ManagerApprove: ['', [Validators.required]]
      });
    }
    else if (decisionValue == RestudyEconomicDecision.ManagerModify) {
      this.EconomicManagerForm = this.formBuilder.group({
        ManagerDecision: ['', [Validators.required]],
        ManagerApprove: ['', [Validators.required]],
      });
    }
  }
  buildForm(decision) {
    this.WorkflowActionForm = this.formBuilder.group({
      workflowDecision: [''],
      Admins: [null, [Validators.required]]
    });
    this.initiateworkflowForm = this.formBuilder.group({
      selectinitiateworkflow: [''],
      Admins: [null, [Validators.required]],
      ActualRebateAmount:  ['', [Validators.required,Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
      RebateAmountAsPerInvoice:  ['', [Validators.required,Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
    });
    this.CancelRebateworkflowForm = this.formBuilder.group({

      Message: [null, [Validators.required]],
      Admins: [null, [Validators.required]]
    });


    this.restudyManagerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });

    if (decision == RestudyEconomicManagerDecision.Approve) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Approve: ['', [Validators.required]]
      });
    }
    else if (decision == RestudyEconomicManagerDecision.Modify) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Modify: ['', [Validators.required]],
      });
    }

    else if (decision == RestudyEconomicManagerDecision.Cancel) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Cancel: ['', [Validators.required]],
      });
    }
    else if (decision == RestudyEconomicManagerDecision.MoreInformation) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }
  get form() {
    return this.EconomicManagerForm.controls;
  }
  get Validate() {
    return this.initiateworkflowForm.controls;
  }
  get workflowActionForm() {
    return this.WorkflowActionForm.controls;
  }
  listChanged() {

    if (this.Validate.Admins && this.Validate.Admins.value != null) {
      this.selectedEmails = this.Validate.Admins.value.map(function (e) {
        return e.Email;
      });
    } else if (this.workflowActionForm.Admins && this.workflowActionForm.Admins.value != null) {
      this.selectedEmails = this.workflowActionForm.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }
  OnInitiateWorkflow() {

    if (!this.isSubmitEnabled)
      this.isSubmitEnabled = true;
      this.longhaulserv.GetNextStepUsers('SCAServices_RefundFirstReviewer').subscribe(d => {
      this.isRestudy = false;
      this.ListOfAdmins = d.Data;
      this.showML = true;
      this.isSubmitButtonDisplayed = true;
      this.globalSrv.IsLoaderEnabled = false;
    });
}
rebateAmountChanged(){
  if(this.initiateworkflowForm.get('RebateAmountAsPerInvoice').value!="" && this.initiateworkflowForm.get('ActualRebateAmount').value!=""){
    this.diffAmount = (this.initiateworkflowForm.get('RebateAmountAsPerInvoice').value - this.initiateworkflowForm.get('ActualRebateAmount').value).toString();

  }
}
  getreleaseFormData(){
    this.longhaulserv.GetReleaseFormByFormID(this.releaseformid).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestCompleted()
    );
  }
  getRebateRequestCompleted(){
    if (this.getRebateRequestResponseObject.Success) {

      this.releaseFormLoaded = this.getRebateRequestResponseObject.Data as ReleaseOpject;
      this.eunitSignedUsersCount = this.restudyRequestObj.EunitSignedUsersNo || 0;
      if (this.eunitSignedUsersCount >= 2) {
        this.showProceedToManagers = true;
      }
      this.isLoaded = true;

      if (history.state.data) {
        this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
        if(this.restudyRequestObj.MeasManagerCanceledRbateDecision == 2){
          this.showModifications = true,
          this.moreInfoMessage =  this.restudyRequestObj.MeasManagerCanceledRbateNote;
        }
        if (this.restudyRequestObj.MeasReviewerCanceledRbateDecision != null) {
          if (this.restudyRequestObj.MeasReviewerCanceledRbateDecision == 2) {
            this.isRequireModification = true;
            this.RequireModificationNote = this.restudyRequestObj.MeasReviewerCanceledRbateNote;
          }
        }
        if (this.restudyRequestObj.MeasManagerCanceledRbateDecision != null) {
          if (this.restudyRequestObj.MeasManagerCanceledRbateDecision == 2) {
            this.isRequireModification = true;
            this.RequireModificationNote = this.restudyRequestObj.MeasManagerCanceledRbateNote;
          }
        }
        if (this.decisionValue == 3) {
          this.isCancelRebate = true;
          this.longhaulserv.GetNextStepUsers('SCAServices_RestudyReviewer').subscribe(d => {
            // this.isRestudy = false;
            this.ListOfAdmins = d.Data;
            //this.showML = true;
            //this.isSubmitButtonDisplayed = true;
            //this.globalSrv.IsLoaderEnabled = false;

          });
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {
          this.showAmount= true;
          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
            Modify: this.restudyRequestObj.EunitRegisterNotes
          });
          this.NewActualRebatePercentage= this.restudyRequestObj.EunitRegisterNotes;
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve) {
          this.showAmount= true;

          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
            Approve: this.restudyRequestObj.EunitRegisterNotes
          });
          debugger;
          this.NewActualRebatePercentage= this.releaseFormLoaded.TransitRebatePercentage;
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Cancel) {
          this.initiateworkflowForm.get('ActualRebateAmount').clearValidators();
          this.initiateworkflowForm.get('ActualRebateAmount').updateValueAndValidity();
          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
            Cancel: this.restudyRequestObj.EunitRegisterNotes
          });
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.MoreInformation) {
          this.initiateworkflowForm.get('ActualRebateAmount').clearValidators();
          this.initiateworkflowForm.get('ActualRebateAmount').updateValueAndValidity();
          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
            MoreInformation: this.restudyRequestObj.EunitRegisterNotes
          });
        }
        this.formMode = FormMode.Readonly;
        this.restudyManagerForm.disable();
      }

      if (this.requestStatus == ServiceStatus.Restudy_NotifyCreator || this.requestStatus == ServiceStatus.Restudy_NotifyCreatorCancelation) {

        this.formMode = FormMode.Readonly;
        this.restudyManagerForm.disable();
        this.EconomicManagerForm.disable();


        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve) {
          this.initiateworkflowForm.get('ActualRebateAmount').clearValidators();
          this.initiateworkflowForm.get('ActualRebateAmount').updateValueAndValidity();
          this.EconomicManagerForm.patchValue({
            ManagerDecision: this.restudyRequestObj.EunitApproveDecision,
            ManagerApprove: this.restudyRequestObj.EunitApproveNotes
          });
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Cancel) {
          this.initiateworkflowForm.get('ActualRebateAmount').clearValidators();
          this.initiateworkflowForm.get('ActualRebateAmount').updateValueAndValidity();
          this.EconomicManagerForm.patchValue({
            ManagerDecision: this.restudyRequestObj.EunitApproveDecision,
            ManagerApprove: this.restudyRequestObj.EunitApproveNotes
          });
        }
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.MoreInformation) {
          this.initiateworkflowForm.get('ActualRebateAmount').clearValidators();
          this.initiateworkflowForm.get('ActualRebateAmount').updateValueAndValidity();
          this.EconomicManagerForm.patchValue({
            ManagerDecision: this.restudyRequestObj.EunitApproveDecision,
            ManagerApprove: this.restudyRequestObj.EunitApproveNotes
          });
        }

      }
      else {
        this.formMode = FormMode.Readonly;
        this.restudyManagerForm.disable();
        this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
        if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {

          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
            MoreInformation: this.restudyRequestObj.EunitRegisterNotes
          });
        }
        else {
          this.buildForm(this.decisionValue);
          this.restudyManagerForm.patchValue({
            Decision: this.decisionValue,
          });
        }
      }

    }
  }


  changeDecision(value) {
    this.buildManagerForm(value);
    this.EconomicManagerForm.patchValue({
      ManagerDecision: value
    });
    this.ShowApprove = true;
    this.MdecisionValue = value;
  }
  getRequest() {

    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.restudyRequestObj = this.responseObj.Data;
          this.requestStatus = this.restudyRequestObj.BaseRequest.StatusId;
          this.releaseformid= this.restudyRequestObj.ReleaseRequestId;
          this.getreleaseFormData();
        }
      }
    )
  }


  onSubmit(proceedToManagers: boolean) {

    this.submitted = true;

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;


    this.restudyAdminObj.AdminEmail = this.user.UserName;
    this.restudyAdminObj.Id = this.baseRequestId;

    this.restudyAdminObj.EunitApproveDecision = this.MdecisionValue;
    this.restudyAdminObj.EunitRegistersDecision = this.decisionValue;
    this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerApprove.value;
    if (this.MdecisionValue == RestudyEconomicManagerDecision.Approve) {
      this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerApprove.value;
      this.restudyAdminObj.EunitSignedUsersCount = this.eunitSignedUsersCount + 1;
    } else {
      this.restudyAdminObj.EunitApproveNotes = this.EconomicManagerForm.controls.ManagerApprove.value;
    }
    if (proceedToManagers) {
      this.restudyAdminObj.ProceedToManagers = true;
    }
    this.longhaulserv.SubmitEconomicManagerDecision(this.restudyAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.EconomicManagerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }
        });
  }
  SubmitRefundWorkflow() {
    this.isFormSubmitted = true;
    if(this.initiateworkflowForm.valid && this.selectedEmails!=null && this.selectedEmails.length!= 0)
    {


        this.StartRefundWorflow();

    }

  }

  SubmitCancelWorkflow() {

    this.submitted = true;
    if (this.selectedEmails != null && this.selectedEmails.length != 0) {
      this.alertService.clear();
      this.globalSrv.isLoaderEnabled = true;
      this.loading = true;

      this.restudyAdminObj.WFNextUsers = this.selectedEmails;
      this.restudyAdminObj.AdminEmail = this.user.UserName;
      this.restudyAdminObj.Id = this.baseRequestId;

      this.restudyAdminObj.MeasCreatorCancelationFromula = this.CancelRebateworkflowForm.controls.Message.value;

      this.longhaulserv.SubmitCancelRebateWorkflow(this.restudyAdminObj)
        .subscribe(
          (data: ResponseObject) => {
            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.EconomicManagerForm.reset();
              this.loading = false;
              this.showRequest = true;
              this.isErrorMessage = false;
            }
            else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
              this.lockTaskErrorMessage = true;
              this.showRequest = true;
              this.globalSrv.isLoaderEnabled = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              this.loading = false;
            }
          });
    }
    else if (this.CancelRebateworkflowForm.invalid) {
      return;
    }

  }
  StartRefundWorflow() {

    this.submitted = true;
    if (this.selectedEmails != null && this.selectedEmails.length != 0) {
      this.alertService.clear();
      this.globalSrv.isLoaderEnabled = true;
      this.loading = true;
      debugger;
      this.initateRefundObj.WFNextUsers = this.selectedEmails;
      //this.initateRefundObj.IsWFExists = true;
      this.initateRefundObj.WFToTerminate = this.baseRequestId;
      this.initateRefundObj.AdminEmail = this.user.UserName;
      this.initateRefundObj.ReleaseRequestId = this.releaseformid;
      if(this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve || this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify){
        this.initateRefundObj.ActualRebateAmount = this.initiateworkflowForm.controls.ActualRebateAmount.value;
        this.initateRefundObj.RebateAmountAsPerInvoice = this.initiateworkflowForm.controls.RebateAmountAsPerInvoice.value;
        this.initateRefundObj.diffAmount = this.diffAmount;
        this.initateRefundObj.ActualRebatePercentage = this.NewActualRebatePercentage;
      }
      else
      {
        this.initateRefundObj.ActualRebateAmount = "";
        this.initateRefundObj.RebateAmountAsPerInvoice = "";
        this.initateRefundObj.diffAmount = "";
        this.initateRefundObj.ActualRebatePercentage = "";
      }


      this.longhaulserv.StartRefundWorflow(this.initateRefundObj)
        .subscribe(
          (data: ResponseObject) => {
            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.EconomicManagerForm.reset();
              this.loading = false;
              this.showRequest = true;
              this.isErrorMessage = false;
            }
            else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
              this.lockTaskErrorMessage = true;
              this.showRequest = true;
              this.globalSrv.isLoaderEnabled = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              this.loading = false;
            }
          });
    }
    else if (this.CancelRebateworkflowForm.invalid) {
      return;
    }

  }

}
